module.exports = __webpack_public_path__ + "img/1493765774.8dfb80bc.jpg";